module.exports = __webpack_public_path__ + "assets/img/form-app-image.c8297b94.jpg";